import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IDedupClipsResponse } from './dedup-clips-response';
import { dedupClipsResponseSchema } from './dedup-clips-response';

export async function dedupClipsApi(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IDedupClipsResponse>> {
  return postRequest<IDedupClipsResponse>({
    path: '/sys/pipeline/dedup-clips',
    schema: dedupClipsResponseSchema,
    options,
  });
}
